import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * CreatorCenterPage - 已弃用
 * 
 * 此页面已被重定向到用户个人资料页面。
 * 用户现在可以直接在个人资料页面上发布作品（通过"发布作品"按钮）。
 */
const CreatorCenterPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    // 等待AuthContext加载完成
    if (loading) return;
    
    if (!user) {
      // 如果用户未登录，重定向到登录页面
      navigate('/login');
      return;
    }
    
    // 重定向到用户个人资料页面
    // 使用 replace 来防止用户后退按钮返回到此页面
    navigate(`/profile/${user.id}`, { replace: true });
  }, [user, loading, navigate]);

  // 显示加载状态
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-testid="creator-center-redirect">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-green-600 mx-auto mb-4" />
        <p className="text-amber-700">{t('common.redirecting', '正在跳转...')}</p>
      </div>
    </div>
  );
};

export default CreatorCenterPage;
